import { object, string, array, optional, type InferInput } from "valibot";
import type { SupportedLanguageCode } from "src/utils/language";
import { fetcher } from "../fetcher";

export async function autocomplete({
  query,
  languageCode,
}: {
  query: string;
  languageCode: SupportedLanguageCode;
}): Promise<AutocompleteResponse> {
  return fetcher("/api/1.6/autocomplete", {
    schema: AutocompleteResponse,
    query: {
      query: query,
      languageCode: languageCode,
    },
  });
}

type AutocompleteResponse = InferInput<typeof AutocompleteResponse>;
export type AutocompletePlace = AutocompleteResponse["results"][number];
const AutocompleteResponse = object({
  request: object({
    query: string(),
    languageCode: string(),
  }),
  results: array(
    object({
      kind: string(),
      shortName: string(),
      longName: string(),
      canonicalName: string(),
      countryCode: optional(string()),
      googlePlaceId: optional(string()),
      link: optional(string()),
    }),
  ),
});
